
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Icon, Menu} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";

export default class Status extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            status: '状态不限',
            optionStateNameList: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getStatusList()
    }

    render() {
        let {optionStateNameList} = this.state;
        let status = (
            <Menu style={{marginTop:'7px'}} onClick={({item, key}) => {
                this.selectMenu(key)
            }}>
                {
                    optionStateNameList && optionStateNameList.length && optionStateNameList.map(optionState =>
                        <Menu.Item style={{background: this.state.status === optionState.key ? "#e6f7ff" : ""}} value={optionState.key} key={optionState.key}>{optionState.key}</Menu.Item>
                    )
                }
            </Menu>
        );
        return (
            <Dropdown overlay={status} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {this.state.status}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }
    selectMenu(data) {
        this.state.status = data;
        this.setState({});
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:'status', data}])
        }
    }

    getStatusList =()=>{
        this.request({
            url: '/search-server/search/getListFromConfig?optionsNames=status',
            method: "get",
            contentType: 'json',
            callBack: (res) => {
                let optionStateNameList = [];
                if(res && res.status){
                    optionStateNameList = res.status;
                }
                this.setState({optionStateNameList})
            }
        })
    }

}